import React, { Component } from 'react';
import {
  formatValidation, getPermissionActions, multipleValidate,
  genaratePaginateFilterSort,
  getPathWithParams
} from '../../../../../../../helpers/functions';
import DEFINE, { PATHS } from '../../../../../../../constants/Define';
import { PageListComponent } from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import Span from '../../../../../common/component/Span';
import TourTicketList from './TourTicketList';
import featureFlags from '../../../../../../../constants/featureFlags';
import { Link, withRouter } from 'react-router-dom';
import './TourTicket.less';
import { get } from "lodash";

let permissionActions = [];
class TourTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTourLine: [],
      filters: {
        pageSize: this.props.tourTicketData?.pageSize,
        pageIndex: this.props.tourTicketData?.pageIndex,
      }
    };
  }

  componentDidMount() {
    permissionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TOUR_TICKETS);
    this.getDetailTourTicket()
  }

  render() {
    const { t, tour, loading, tourTicketData } = this.props;
    const { tourTickets, totalCount, totalPage, pageIndex, pageSize } = tourTicketData || {};
    const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };
    return (
      <Wrapper className="tour-detail-tour-ticket">
        <PageListComponent onChangeLanguage={featureFlags.TRANSLATE_ENABLE && this.onChangeLanguage}>
          <Wrapper className="w-100 pt-3 pb-3 d-flex justify-content-between align-items-center">
            <Span className="tour-name">{t(`item.tourTicket.tourticketList`)}: {tour.name || tour.tourName || ''}</Span>
            {permissionActions && permissionActions.allowCreate &&
              <Link to={getPathWithParams(PATHS.TOUR.TICKET.CREATE.path, { tour_id: tour.id })}
                className='btn btn-primary'>+ {t(`action.create`)}</Link>
            }
          </Wrapper>
          <Wrapper className="pb-1">
            <TourTicketList loading={loading}
              permisions={permissionActions}
              tourTickets={tourTickets || []}
              pagination={pagination}
              onChange={this.onTableChange}
              tour={tour}
              history={this.props.history}
            />
          </Wrapper>
        </PageListComponent>
      </Wrapper>
    )
  }

  onTableChange = (pagination, filters, sorter) => {
    let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
    this.setState({
      filter: newFilters
    });
    this.getDetailTourTicket(newFilters);
  };

  onChangeLanguage = () => {
    this.getDetailTourTicket(this.state.filters);
  }

  getDetailTourTicket = (filters = {}) => {
    const { tour, match } = this.props;
    let tourId = tour.id;
    if (!tourId && match && match.params && match.params.id) {
      tourId = get(match, 'params.id');
    }
    return this.props.getDetailTourTicket(Object.assign(filters, { tourId: tourId }))
  }

  validateTourTicket(tourLine, index) {
    const { t } = this.props;
    let validate = {
      required: {
        departureDate: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.departureDate`)),
        seats: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.seat`)),
      }
    };
    let valueValidate = {

    };
    const result = multipleValidate(tourLine, validate, valueValidate);
    const validationTourLine = this.state.validationTourLine;
    validationTourLine[index] = result;
    this.setState({ validationTourLine });
    return Object.keys(result).length < 1;
  }

}

TourTicket.defaultProps = {
  onChange: () => { },
  onCreate: () => { },
}

export default withRouter(TourTicket);


